import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {MainSearchComponent} from "./components/main-search/main-search.component";
import {AccordionModule, AutoCompleteModule, CalendarModule, DropdownModule, InputTextModule, KeyFilterModule, MultiSelectModule, PaginatorModule, SlideMenuModule, TabViewModule, TriStateCheckboxModule} from "primeng/primeng";
import {DialogModule} from "primeng/dialog";
import {InputMaskModule} from "primeng/inputmask";
import {ChipsModule} from "primeng/chips";
import {ButtonModule} from "primeng/button";
import {SharedModule} from "primeng/shared";
import {OptionsService} from "@services/options-service.service";
import {EsriLoaderService} from "@services/esri-loader.service";
import {HttpClient, HttpClientModule} from "@angular/common/http";

import {FormsModule, NgModel, ReactiveFormsModule} from "@angular/forms";
import {SlicePipe} from "@angular/common";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ChipPipe} from "@directives/chips/chip.pipe";
import {ChipsComponent} from "@directives/chips/chips.directive";
import {CurrencyMaskModule} from "ngx-currency-mask";
import {Http404Component} from "./components/http404/http404.component";
import {SearchService} from "@services/search.service";
import {TableModule} from "primeng/table";
import {Reports} from "@services/reports";
import {AssrNumber} from "@directives/assrNumbers/assrNumber";
import {CardModule} from "primeng/card";
import { MainContainerComponent } from './components/main-container/main-container.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { MapContainerComponent } from './components/map-container/map-container.component';
import {CheckboxModule} from 'primeng/checkbox';
import {RadioButtonModule} from 'primeng/radiobutton';
import { SearchShortResultsComponent } from './components/search-short-results/search-short-results.component';
import { TruncatePipe } from "./pipes/truncate.pipe";

@NgModule({
  declarations:[
    AppComponent,
    MainSearchComponent,
    ChipPipe, ChipsComponent, Http404Component, AssrNumber, MainContainerComponent, SearchResultsComponent, MapContainerComponent, SearchShortResultsComponent, TruncatePipe
  ],
  imports:[
    AccordionModule,
    AppRoutingModule,
    AutoCompleteModule,
    BrowserAnimationsModule,
    BrowserModule,
    ButtonModule,
    CardModule,
    CalendarModule,
    ChipsModule,
    CurrencyMaskModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    HttpClientModule,
    InputTextModule,
    InputMaskModule,
    KeyFilterModule,
    MultiSelectModule,
    PaginatorModule,
    ReactiveFormsModule,
    SharedModule,
    SlideMenuModule,
    TableModule,
    TabViewModule,
    TriStateCheckboxModule,
    CheckboxModule,
    RadioButtonModule
  ],
  providers:[BrowserAnimationsModule, SlicePipe, NgModel, HttpClient, OptionsService, SearchService, Reports, EsriLoaderService],
  bootstrap:[AppComponent]
})
export class AppModule {
}
